<template>
    <game-list ref="gamelist" :provider="provider" :save="save" :sync="sync" :edit="edit" />
</template>
<script>
import gameService from '../../../../../../services/game.service';

import GameList from '../../../../../common/games-list.vue';

export default {
    name: 'branch-games-list',
    components: { GameList },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        branchName() {
            return this.$route.params.branch;
        },
        provider() {
            return this.$route.params.provider;
        }
    },
    watch: {
        async clientId() {
            await this.loadGames();
        },
        async branchName() {
            await this.loadGames();
        },
        async provider() {
            await this.loadGames();
        }
    },
    async mounted() {
        await this.loadGames();
    },
    methods: {
        async loadGames() {
            let games = await gameService.getBranchGames(this.clientId, this.branchName, this.provider);
            this.$refs.gamelist.set(games);
        },
        async save(game) {
            await gameService.saveBranchGame(game, this.clientId, this.branchName);
            await this.loadGames();
        },
        async sync() {
            await gameService.sync(this.provider);
            await this.loadGames();
        },
        async edit(game) {
            await gameService.saveGameProperties(game);
            await this.loadGames();
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/games/branch-games-list.vue